import { Role } from 'domains/models/team_user/role';
import { ProjectItem, ProjectListItem } from 'presentations/api/schema/project';
import { ViewerItem } from 'presentations/api/schema/user';

export const canEditProject = (
  project: ProjectListItem | ProjectItem | undefined | null,
  viewer: ViewerItem,
) => {
  return project?.userId === viewer.uid || isTeamAdmin(viewer.role);
};

export const canDeleteNote = isTeamAdmin;

export const canDeleteNoteTemplate = isTeamAdmin;

export const canDeleteNotePage = isTeamAdmin;

function isTeamAdmin(role: number): boolean {
  return role === Role.Owner || role === Role.Admin;
}
